module.exports = "<div id=\"frame\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sketch/frames/frames.component.html
// module id = 54
// module chunks = 0